var map = {
	"./1x1transparent-dot.png": "7fc1",
	"./EV-ARC-Chevy-Volt-Envision-Solar-solar-car.png": "ef07",
	"./Footer_indianart.png": "02d7",
	"./IndiArt_01.png": "763f",
	"./LOVAL-Logo.svg": "de4c",
	"./LOVAL-Logo_old.svg": "6586",
	"./LOVAL-Will-Version_alone.svg": "6730",
	"./LOVAL-Will-Version_old.svg": "fc8f",
	"./Logo-Reiter.svg": "53b6",
	"./NAVI-CamposLoval_Master_Home_V3.12--Recovered.png": "2353",
	"./brands/Allen Bradley.png": "ff33",
	"./brands/Endress + Hauser.png": "3a31",
	"./brands/Festo.png": "ace0",
	"./brands/Lapp Kabel.png": "8448",
	"./brands/Leuze Electronic.png": "ffdb",
	"./brands/Mitutoyo.png": "9b10",
	"./brands/Omron.png": "42fd",
	"./brands/Phoenix Contact.png": "8af1",
	"./brands/Pilz.png": "2942",
	"./brands/Schneider Electric.png": "b00b",
	"./brands/Sew Eurodrive.png": "21b4",
	"./brands/Sick.png": "85f6",
	"./brands/Siemens.png": "9aab",
	"./brands/TE Connectivity.png": "3f7e",
	"./brands/Wago.png": "610f",
	"./electric.jpg": "7971",
	"./favicon.png": "a171",
	"./flag.png": "5904",
	"./header_01.png": "21d5",
	"./icon_1_off.svg": "5285",
	"./icon_1_on.svg": "53ff",
	"./icon_2_off.svg": "17bd",
	"./icon_2_on.svg": "ffaf",
	"./icon_3_off.svg": "6e5c",
	"./icon_3_on.svg": "5991",
	"./imageContent12.jpg": "e6eb",
	"./imageContent16.jpg": "c454",
	"./imageContent20.jpg": "3b86",
	"./imageContent24.jpg": "4959",
	"./imageContent28.jpg": "e0c8",
	"./imageContent3.jpg": "69e6",
	"./imageContent4.jpg": "8af8",
	"./imageContent8.jpg": "3331",
	"./indianart.png": "a957",
	"./lang_de.png": "0a28",
	"./lang_en.png": "35d4",
	"./lang_es.png": "25d9",
	"./logo_solo.png": "2423",
	"./logos-dritte/GooglePlus.png": "7ba1",
	"./logos-dritte/Linkedin.png": "44fa",
	"./logos-dritte/Mastercad-securecode.png": "75f2",
	"./logos-dritte/Whatsapp.png": "49ce",
	"./logos-dritte/instagram.png": "abe1",
	"./logos-dritte/paypal.png": "60c3",
	"./logos-dritte/twitter.png": "d7cc",
	"./logos-dritte/visa-mastercard.png": "60a0",
	"./logos-dritte/xing.png": "f40a",
	"./measure.jpg": "689e",
	"./mechanic.jpg": "f69c",
	"./pinwand.png": "9f8d",
	"./sectors-img01.jpg": "0d6f",
	"./sectors-img02.jpg": "3537",
	"./sectors-img03.jpg": "8171",
	"./smartphone-586944_1920.jpg": "4e05",
	"./suppliers/Suppliers1.png": "b4a3",
	"./suppliers/Suppliers2.png": "1cad",
	"./suppliers/Suppliers3.png": "bee2",
	"./suppliers/Suppliers4.png": "fefb",
	"./suppliers/Suppliers5.png": "a3be",
	"./suppliers/Suppliers6.png": "9096",
	"./suppliers/Suppliers7.png": "6828"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";